var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2657 0.507235C11.2727 0.444298 12.2657 0.793935 13.0139 1.47923C13.6992 2.22745 14.0488 3.22043 13.9929 4.23438V10.7657C14.0558 11.7796 13.6992 12.7726 13.0209 13.5208C12.2726 14.2061 11.2727 14.5557 10.2657 14.4928H3.73441C2.72045 14.5557 1.72747 14.2061 0.979236 13.5208C0.293935 12.7726 -0.0557019 11.7796 0.00723517 10.7657V4.23438C-0.0557019 3.22043 0.293935 2.22745 0.979236 1.47923C1.72747 0.793935 2.72045 0.444298 3.73441 0.507235H10.2657ZM6.28678 10.8915L10.993 6.17141C11.4195 5.73783 11.4195 5.03855 10.993 4.61199L10.0839 3.70293C9.65035 3.26938 8.95105 3.26938 8.51754 3.70293L8.04896 4.17844C7.97903 4.24837 7.97903 4.36724 8.04896 4.43717C8.04896 4.43717 9.16084 5.54203 9.18184 5.57C9.25877 5.65392 9.3077 5.7658 9.3077 5.89167C9.3077 6.14341 9.10491 6.3532 8.84619 6.3532C8.72726 6.3532 8.6154 6.30427 8.53847 6.22734L7.37066 5.06652C7.31473 5.01058 7.21687 5.01058 7.16087 5.06652L3.82532 8.4021C3.59455 8.63282 3.46169 8.94054 3.4547 9.26919L3.41274 10.9264C3.41274 11.0174 3.44071 11.1013 3.50365 11.1642C3.56659 11.2272 3.6505 11.2621 3.74141 11.2621H5.38472C5.72041 11.2621 6.04206 11.1292 6.28678 10.8915Z",
    fill: "#1B80C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGrayIcon);
export default __webpack_public_path__ + "static/media/edit_gray_icon.193e5d91f75f728a5990ffe0bc7c4692.svg";
export { ForwardRef as ReactComponent };